<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Reporte</h1>

      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area">
            <div class="row">
              <div class="col-6"><span>Periodo de Radicación</span></div>
              <div class="col-6"><span>Periodo de Sentencia</span></div>
            </div>
            <div class="row" v-on:keyup.enter="getReporteQuejasAdministrativas">
              <div class="col-3"><input type="date" class="form-control" v-model="fechaInicialPeriodoRadicacion" /></div>
              <div class="col-3"><input type="date" class="form-control" v-model="fechaFinalPeriodoRadicacion" /></div>
              <div class="col-3"><input type="date" class="form-control" v-model="fechaInicialPeriodoSentencia" /></div>
              <div class="col-3"><input type="date" class="form-control" v-model="fechaFinalPeriodoSentencia" /></div>
            </div>
            <div class="row new-row">
              <div class="col-3"><span>Consecutivo</span></div>
              <div class="col-3"><span>Sentido de la Sentencia</span></div>
              <div class="col-3"><span>Involucrados</span></div>
            </div>
            <div class="row" v-on:keyup.enter="getReporteQuejasAdministrativas">
              <div class="col-3"><input type="text" class="form-control" v-model="consecutivo" /></div>
              <div class="col-3">
                <C003TiposDeSentidoDeSentencia v-on:valorParaElPadre="cambioTipoDeSentidoDeSentencia"
                                               :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                               :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                               :idDelInput="'catalogoTipoDeSentidoDeSentencia'"
                                               :parametros="parametros_TipoDeSentidoDeSentencia"
                                               :valorDefinido="parametros_TipoDeSentidoDeSentencia.valorDefinido">
                </C003TiposDeSentidoDeSentencia>
              </div>
              <div class="col-3"><input type="text" class="form-control" v-model="textoBusqueda" /></div>
              <div class="col-3"><input type="button" class="form-control" value="Buscar" @click="getReporteQuejasAdministrativas" /></div>
            </div>
            <div class="row" style="margin-top:30px;" v-if="quejasAdministrativas.length > 0">
              <div class="col-5"></div>
              <div class="col-3">
                <button  class="form-control" @click="descargarArchivoExcel"><i class="fas fa-file-excel" ></i><span>Descargar Reporte en Excel</span></button>
              </div>
              <div class="col-3">
                <button class="form-control" @click="descargarArchivoPdf"><i class="fas fa-file-pdf"></i></button>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-12">
                <table class="table table-striped table-light table-hover" id="tablaQuejasAdministrativas">
                  <thead class="thead-dark">
                    <tr>
                      <th class="col-1">No. QA</th>
                      <th class="col-1">Consecutivo</th>
                      <th class="col-3">Involucrados</th>
                      <th class="col-4">Sentido de la Sentencia / Sanción</th>
                      <th class="col-1">Fecha de Radicación</th>
                      <th class="col-1">Fecha de Sentencia</th>
                      <th class="col-1">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="(queja) in quejasAdministrativas" v-bind:key="queja.quejaAdministrativaId">
                      <td>{{queja.quejaAdministrativaId}}</td>
                      <td>{{queja.consecutivo}}</td>
                      <td v-html="mostrarInvolucradosQuejaAdministrativa(queja)"></td>
                      <td>{{queja.tipoDeSentidoDeSentencia.nombre}} <br />{{queja.sancion}}</td>
                      <td>{{new Date(queja.fechaDeRadicacion).toLocaleDateString('es-MX', opcionesFechaLocal)}}</td>
                      <td>
                        <template v-if="queja.fechaDeSentencia">
                          {{new Date(queja.fechaDeSentencia).toLocaleDateString('es-MX', opcionesFechaLocal)}}
                        </template>
                        <template v-else>
                          Pendiente
                        </template>
                      </td>
                      <td>
                        <i class="fas fa-edit fa-lg" title="Editar Queja Administrativa" @click="editarQueja(queja.quejaAdministrativaId)" />
                        <i class="fas fa-trash fa-lg" title="Eliminar Queja Administrativa" @click="abrirModalConfirmarCancelacionQueja(queja.quejaAdministrativaId)" />
                      </td>
                    </tr>
                    <tr v-if="quejasAdministrativas.length == 0"><td colspan="7">No se encontraron quejas administrativas.</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <ModalConfirmarCancelacionQueja :quejaAdministrativaId="parametrosModalConfirmarCancelacionQueja.quejaAdministrativaId"
                                    v-on:valorParaElPadre="quitarQuejaCancelada">
        </ModalConfirmarCancelacionQueja>
      </div>
    </div>
  </div>
</template>
<script>
  
  import catalogos from '@/../static/js/catalogos'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';
  import store from '@/store/index'
  import enumeraciones from '@/../static/js/enumeraciones'
  import ModalConfirmarCancelacionQueja from '@/components/SIQA/QuejasAdministrativas/ReporteQuejasAdministrativas/ModalConfirmarCancelacionQueja.vue'
  export default {
    data() {
      return {
        enumeraciones,
        catalogos,
        fechaInicialPeriodoRadicacion: null,
        fechaFinalPeriodoRadicacion: null,
        fechaInicialPeriodoSentencia: null,
        fechaFinalPeriodoSentencia: null,
        parametros_TipoDeSentidoDeSentencia: {
          valorDefinido: -1,
          tipoDeSentidoDeSentenciaId: null
        },
        consecutivo: "",
        textoBusqueda: "",
        quejasAdministrativas: [],
        opcionesFechaLocal: { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' },
        parametrosModalConfirmarCancelacionQueja: { quejaAdministrativaId: -1 },
        rutaReporteExcel: "",
        rutaReportePdf: ""
      }
    },
    props: {
    },
    mounted() {
      this.fijarFechasDefault();
      this.getReporteQuejasAdministrativas();
    },
    components: {
      C003TiposDeSentidoDeSentencia: catalogos.SIQA.C003TiposDeSentidoDeSentencia,
      ModalConfirmarCancelacionQueja
    },
    methods: {
      getReporteQuejasAdministrativas: function () { //Retorna una lista de citas 'Aceptadas'
        var peticion = {
          "fechaInicialPeriodoRadicacion": this.fechaInicialPeriodoRadicacion,
          "fechaFinalPeriodoRadicacion": this.fechaFinalPeriodoRadicacion,
          "fechaInicialPeriodoSentencia": this.fechaInicialPeriodoSentencia,
          "fechaFinalPeriodoSentencia": this.fechaFinalPeriodoSentencia,
          "consecutivo": this.consecutivo,
          "tipoDeSentidoDeSentenciaId": this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId,
          "textoBusqueda": this.textoBusqueda
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIQA.funciones.GetReporteQuejasAdministrativas, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.quejasAdministrativas = response.data.quejasAdministrativas;
            this.rutaReporteExcel = response.data.rutaReporteExcel;
            this.rutaReportePdf = response.data.rutaReportePdf;
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          comun.SeEstaCargandoInformacion(false);
        });
      },
      descargarArchivoExcel: function () {
        alert('Excel');
        if (this.rutaReporteExcel != undefined) {
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${this.rutaReporteExcel}`
          console.log(a.href);
          a.click();
        }
      },
      descargarArchivoPdf: function () {
        alert('Pdf');
        if (this.rutaReportePdf != undefined) {
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${this.rutaReportePdf}`
          console.log(a.href);
          a.click();
        }
      },
      cambioTipoDeSentidoDeSentencia(datos) { //Administra los cambios en el componente de Área
        catalogos
        this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId = parseInt(datos[0].target.value)
      },
      mostrarInvolucradosQuejaAdministrativa(quejaAdministrativa) {
        let listaQuejosos = quejaAdministrativa.quejaAdministrativa_involucrados.filter(qa_inv => qa_inv.tipoDeInvolucradoId === 1).map(qa_inv => qa_inv.involucrado)
          .map(involucrado => `<li>${this.obtenerNombreCompleto(involucrado.nombre, involucrado.apellidoPaterno, involucrado.apellidoMaterno)}</li>`).join('');
        let listaDemandados = quejaAdministrativa.quejaAdministrativa_involucrados.filter(qa_inv => qa_inv.tipoDeInvolucradoId === 2).map(qa_inv => qa_inv.involucrado)
          .map(involucrado => `<li>${this.obtenerNombreCompleto(involucrado.nombre, involucrado.apellidoPaterno, involucrado.apellidoMaterno)} : <b>${involucrado.cargo}</b></li>`).join('');
        let listaFinal = `<span>Quejosos</span><ul>${listaQuejosos}</ul><span>Demandados</span><ul>${listaDemandados}</ul>`
        //quejosos = 
        return listaFinal;
      },
      obtenerNombreCompleto(nombre, apellidoPaterno, apellidoMaterno) {
        return [nombre, apellidoPaterno, apellidoMaterno].filter(palabra => palabra.length > 0).join(' ');
      },
      fijarFechasDefault: function () { //Fija la fecha inicial del formulario como el primer día del mes en curso.
        var date = new Date();
        this.fechaInicialPeriodoRadicacion  = new Date(date.getFullYear(), date.getMonth(), 1).toISOString().split('T')[0];
        this.fechaFinalPeriodoRadicacion  = new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString().split('T')[0];
      },
      abrirModalConfirmarCancelacionQueja(quejaAdministrativaId) {
        this.parametrosModalConfirmarCancelacionQueja.quejaAdministrativaId = quejaAdministrativaId;
        $('#modalConfirmarCancelacionQueja').modal('toggle');
      },
      editarQueja(quejaAdministrativaId) {
        //console.log(quejaAdministrativaId)
        this.$router.push({ name: 'EditarQueja', params: { quejaAdministrativaId: quejaAdministrativaId } })
      },
      quitarQuejaCancelada(datos) { //Administra los cambios en el componente de Área
        catalogos
        console.log(datos)
        this.quejasAdministrativas = this.quejasAdministrativas.filter(qa => qa.quejaAdministrativaId !== datos);
      }

    },
    created() {

    }
  }
</script>

<style scoped>


  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SIQA/QuejasAdministrativas/ReporteQuejasAdministrativas/ReporteQuejasAdministrativas.vue